<template>
  <div v-if="isVisible" class="overlay" @click="closeDialog">
    <div class="portal" @click.stop>
      <h2 class="dialog-title">{{ translatedTitle }}</h2>
      <p>
        {{ translatedMessage1 }}
      </p>
      <p>
        {{ translatedMessage2 }}
        <a :href="translatedLink" target="_blank"
          ><b>{{ translatedHere }}</b></a
        >.
      </p>

      <div class="footer">
        <button class="btn close-button" type="button" @click="closeDialog">
          {{ translatedClose }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeDialog: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isVisible: true
    };
  },
  computed: {
    translatedTitle() {
      const lang = this.$store.getters.lang;
      return {
        en: "Important Notice",
        pt: "Aviso Importante",
        es: "Aviso Importante"
      }[lang];
    },
    translatedMessage1() {
      const lang = this.$store.getters.lang;
      return {
        en:
          "This page is for business inquiries only.  Please use your corporate e-mail address on the form.",
        pt:
          "Esta página é apenas para consultas comerciais.  Por favor, use seu e-mail corporativo no formulário.",
        es:
          "Esta página es solo para consultas comerciales.  Por favor, use su correo electrónico corporativo en el formulario."
      }[lang];
    },
    translatedMessage2() {
      const lang = this.$store.getters.lang;
      return {
        en: "If you are looking to join our survey panel, please click",
        pt:
          "Se você está procurando se juntar ao nosso painel de pesquisa, clique",
        es: "Si está buscando unirse a nuestro panel de encuestas, haga clic"
      }[lang];
    },
    translatedHere() {
      const lang = this.$store.getters.lang;
      return {
        en: "here",
        pt: "aqui",
        es: "aquí"
      }[lang];
    },
    translatedLink() {
      const lang = this.$store.getters.lang;
      return {
        en: "https://www.queopinas.com/",
        pt: "https://www.voceopina.com.br/",
        es: "https://www.queopinas.com/"
      }[lang];
    },
    translatedClose() {
      const lang = this.$store.getters.lang;
      return {
        en: "Close",
        pt: "Fechar",
        es: "Cerrar"
      }[lang];
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.portal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  text-align: center;
}

.dialog-title {
  font-family: Arial, sans-serif;
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}

.portal p {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  margin-bottom: 16px;
}

.portal a {
  color: #007bff;
  text-decoration: none;
}

.portal a:hover {
  text-decoration: underline;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.close-button {
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff;
  font-size: 0.8rem;
  background: #6b6b6b;
  box-shadow: 5px 5px 16px rgba(45, 97, 135, 0.3);
  border-radius: 100px;
  font-weight: 500;
  padding: 3px 20px 3px 20px;
  transition: all 0.3s ease;
}

.close-button:hover {
  text-decoration: none;
  color: #ffffff;
  background: #5a5a5a;
}
</style>
